import {Component, Input} from '@angular/core';
import {AbstractDialogComponent} from '@wba-ui-module/components/dialogs/abstract-dialog.component';

@Component({
    selector: 'wba-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    standalone: false
})
export class ModalDialogComponent extends AbstractDialogComponent {

  @Input() headerTitle = 'TITEL NICHT VORHANDEN';
  @Input() targetId = 'ModalDialog';

  constructor() {
    super();
  }
}
